// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchCard {
    background-color:#1976d2;
    background-color:#1565c0;
    background-color:rgba(0, 0, 255,0);
    border-radius:20px;
    padding-left:20px;
    padding-right:20px;
    padding-bottom:20px;
    padding-top:10px;
    -webkit-user-select: none;
            user-select: none;
    letter-spacing: -.08em;
    width:95%;
    margin:auto;
    margin-top:100px;
    text-shadow: none;
    box-shadow:none;
}

.inputDiv {


}

input.gbSearch {
    box-sizing: border-box;
    background-color:rgba(255,255,255,.25);
    border-radius:30px;
    border:2px solid rgba(255,255,255,.2);
    padding-left:60px;
    font-size:30px;
    padding-top:12px;
    padding-bottom:12px;
    height:60px;
    position: relative;
    vertical-align: top;
    width:400px;
    transition: all .5s;
    cursor: pointer;
}

input.gbSearch:hover {
    border:2px solid rgba(255,255,255,.5);
}
input.gbSearch:focus {
    background-color:white;
    border:2px solid rgba(255,255,255,1);
    width:450px;
}

.mGlass {
    position: relative;
    top:-54px;
    left:18px;
    font-size:32px;
    color:black;
}

.myCloser {
    position: relative;
    right:20px;
    font-size:30px;
    top: -50px;
    float:right;
    font-weight: 700;
    color:rgba(0, 0, 0, 0);
   
    cursor: pointer;
}

.myCloser:hover {
    color:black;
}
.startSearch {
    padding:20px;
    border:none;
    border-radius:30px;
    background-color:rgb(0, 59, 147);
    color:white;
    text-transform:uppercase;
    width:20%;
    box-sizing: border-box;
    height:60px;
    padding:10px;
    font-size:20px;
    font-weight: 600;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    min-width:190px;
    margin-top:0;
    /* box-shadow:0 0 8px rgb(4, 26, 97); */
}

.startSearch:hover {
    background-color:rgb(0, 59, 147);
    background-color:rgb(16, 28, 56);

}

.myInputField {
    display:inline-block;
    float:left;
    box-sizing: border-box;
    height:76px;
    overflow: hidden;
    margin-right:24px;

}


.startSearch:visited, .startSearch:active, .startSearch:focus {
    background-color:rgb(0, 59, 147);
}



@media only screen and (min-width: 800px) {
  

        .searchCard {
            margin-top:160px;
        }

        input.gbSearch {
            width:500px;
        }

        input.gbSearch:focus {
            background-color:white;
            border:2px solid rgba(255,255,255,1);
            width:600px;
        }
    
}`, "",{"version":3,"sources":["webpack://./src/components/searchbar.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;;AAGA;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,sBAAsB;;IAEtB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,wBAAwB;IACxB,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;;AAEpC;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;;AAErB;;;AAGA;IACI,gCAAgC;AACpC;;;;AAIA;;;QAGQ;YACI,gBAAgB;QACpB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,sBAAsB;YACtB,oCAAoC;YACpC,WAAW;QACf;;AAER","sourcesContent":[".searchCard {\n    background-color:#1976d2;\n    background-color:#1565c0;\n    background-color:rgba(0, 0, 255,0);\n    border-radius:20px;\n    padding-left:20px;\n    padding-right:20px;\n    padding-bottom:20px;\n    padding-top:10px;\n    user-select: none;\n    letter-spacing: -.08em;\n    width:95%;\n    margin:auto;\n    margin-top:100px;\n    text-shadow: none;\n    box-shadow:none;\n}\n\n.inputDiv {\n\n\n}\n\ninput.gbSearch {\n    box-sizing: border-box;\n    background-color:rgba(255,255,255,.25);\n    border-radius:30px;\n    border:2px solid rgba(255,255,255,.2);\n    padding-left:60px;\n    font-size:30px;\n    padding-top:12px;\n    padding-bottom:12px;\n    height:60px;\n    position: relative;\n    vertical-align: top;\n    width:400px;\n    transition: all .5s;\n    cursor: pointer;\n}\n\ninput.gbSearch:hover {\n    border:2px solid rgba(255,255,255,.5);\n}\ninput.gbSearch:focus {\n    background-color:white;\n    border:2px solid rgba(255,255,255,1);\n    width:450px;\n}\n\n.mGlass {\n    position: relative;\n    top:-54px;\n    left:18px;\n    font-size:32px;\n    color:black;\n}\n\n.myCloser {\n    position: relative;\n    right:20px;\n    font-size:30px;\n    top: -50px;\n    float:right;\n    font-weight: 700;\n    color:rgba(0, 0, 0, 0);\n   \n    cursor: pointer;\n}\n\n.myCloser:hover {\n    color:black;\n}\n.startSearch {\n    padding:20px;\n    border:none;\n    border-radius:30px;\n    background-color:rgb(0, 59, 147);\n    color:white;\n    text-transform:uppercase;\n    width:20%;\n    box-sizing: border-box;\n    height:60px;\n    padding:10px;\n    font-size:20px;\n    font-weight: 600;\n    user-select: none;\n    cursor: pointer;\n    min-width:190px;\n    margin-top:0;\n    /* box-shadow:0 0 8px rgb(4, 26, 97); */\n}\n\n.startSearch:hover {\n    background-color:rgb(0, 59, 147);\n    background-color:rgb(16, 28, 56);\n\n}\n\n.myInputField {\n    display:inline-block;\n    float:left;\n    box-sizing: border-box;\n    height:76px;\n    overflow: hidden;\n    margin-right:24px;\n\n}\n\n\n.startSearch:visited, .startSearch:active, .startSearch:focus {\n    background-color:rgb(0, 59, 147);\n}\n\n\n\n@media only screen and (min-width: 800px) {\n  \n\n        .searchCard {\n            margin-top:160px;\n        }\n\n        input.gbSearch {\n            width:500px;\n        }\n\n        input.gbSearch:focus {\n            background-color:white;\n            border:2px solid rgba(255,255,255,1);\n            width:600px;\n        }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
